import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, Menu, VolumeX, Warehouse } from 'lucide-react';
import { Button } from '../../../components/ui/Button';

/**
 * The bar on top: back, where the operator is, which warehouse, and the menu.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string|null} props.backTo
 * @param {string} [props.warehouseName]
 * @param {boolean} [props.muted] - Sound off on this device.
 * @param {() => void} props.onMenu
 */
export const OperatorTopBar = ({ title, backTo, warehouseName, muted, onMenu }) => (
  <div className="flex h-16 items-center gap-2 px-2">
    {backTo ? (
      <Link
        to={backTo}
        aria-label="Volver"
        data-testid="operator-back"
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-ninja-dark hover:bg-ninja-gray dark:text-white dark:hover:bg-[#2d2d2d]"
      >
        <ChevronLeft size={26} />
      </Link>
    ) : (
      <div className="flex h-12 w-12 shrink-0 items-center justify-center text-ninja-green">
        <Warehouse size={24} />
      </div>
    )}
    <div className="min-w-0 flex-1">
      <p data-testid="operator-title" className="truncate text-lg font-bold text-ninja-dark dark:text-white">
        {title}
      </p>
      {warehouseName && (
        <p data-testid="operator-warehouse-name" className="truncate text-xs text-text-secondary">
          {warehouseName}
        </p>
      )}
    </div>
    {muted && <VolumeX size={18} className="shrink-0 text-text-muted" aria-label="Sonido apagado" />}
    <Button
      variant="subtle"
      size="lg"
      iconOnly
      icon={Menu}
      aria-label="Menú"
      onClick={onMenu}
      data-testid="operator-menu-open"
    />
  </div>
);
